import axios from 'axios';
import { logout, refreshToken } from './auth';
import { getBaseUrl } from './helpers';

// API Endpoints
const GET_BUILDING_LIST_ENDPOINT = `/building/api/buildings/?partial=1&is_pi=1`;

export * from './auth';
export * from './savings';
export * from './incidents';
export * from './diagnostics';

export const getBuildingList = async (env, search = '') => {
  const BASE_URL = getBaseUrl(env);
  const API_ENDPOINT = search ? `/building/api/buildings/?search=${search}` : GET_BUILDING_LIST_ENDPOINT;
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  let response;

  if (!authToken) {
    await refreshToken(env);
    authToken = JSON.parse(sessionStorage.getItem('token'));
  }

  // Make the request only if there is an authorization token
  if (authToken) {
    response = axios
      .get(`${BASE_URL}${API_ENDPOINT}`, {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          const refreshTokenStatus = await refreshToken(env);
          return refreshTokenStatus === 200 ? getBuildingList(env) : logout();
        }
        return Promise.reject(error.response.data.errors[0].message);
      });
  }

  return response;
};
